// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var inject = allVue.inject;
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, noRecords } from './messages';
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * Represents the GridNoRecords component which is rendered
 * when the `data` property of the Grid is empty or `null`.
 *
 * @example
 * ```tsx-no-run
 *   <div id="app">
 *       <Grid
 *           :data-items="products"
 *           :columns="columns">
 *       <grid-norecords>
 *        There is no data available custom
 *        </grid-norecords>
 *       </Grid>
 *   </div>
 * <script>
 *       Vue.component('Grid', Grid);
 *       Vue.component('grid-norecords', GridNoRecords);
 *       new Vue({
 *           el: '#app',
 *           data: function () {
 *               return {
 *                  products: [
 *                    { 'foo': 'A1', 'bar': 'B1' },
 *                       { 'foo': 'A2', 'bar': 'B2' },
 *                       { 'foo': 'A3', 'bar': 'B2' }
 *                   ],
 *                   columns: [
 *                       { field: 'foo'},
 *                       { field: 'bar'}
 *                   ]
 *               };
 *           }
 *       });
 *   </script>
 * ```
 */

/**
 * Represents the default `GridNoRecords` component.
 */

var GridNoRecords = {
  name: 'GridNoRecords',
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    var localizationService = provideLocalizationService(this);
    var noRecordsMessage = localizationService.toLanguageString(noRecords, messages[noRecords]);
    return defaultSlot ? h("div", [defaultSlot]) // @ts-ignore
    : this.v3 ? noRecordsMessage : this._v(noRecordsMessage);
  }
};
export { GridNoRecords };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-grid/dist/es/GridNoRecords.js
// module id = 370
// module chunks = 93